import { Mode } from '@/common/entityFramework/enumerations/Mode';
import { ExprUtils } from '@/common/utils/ExprUtils';

export const navigateToInvList = (dataPoint, selectedPeriod, selectedPbms, selectedCtrts, navigateTo) => {

  const invStatus = dataPoint.invStatus;
  let expr = ExprUtils.whereParams('cldStatus', invStatus);

  const pbmIds = selectedPbms.map(pbm => pbm.id);
  const ctrtIds = selectedCtrts.map(ctrt => ctrt.id);
  const selectedPeriodId = selectedPeriod?.id;
  if (selectedPeriodId) {
    expr = ExprUtils.and(expr, ExprUtils.whereParams('invPeriodId', selectedPeriodId, 'pbmId', pbmIds, 'ctrtId', ctrtIds));
  }
  
  const navState = {
    mode: Mode.LIST,
    expr: expr,
  };

  navigateTo('sc/mco-inv', navState);
};